<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="modal-confirm-mail" hide-footer id="modal-confirm-mail">
      <h4 class="text-center">¿Está seguro de validar la Liga de Pago? El cliente será notificado vía email.</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-mail')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="guardarHandler">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-pagado" hide-footer id="modal-confirm-pagado">
      <h4 class="text-center">¿Está seguro de validar el pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-pagado')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="processPagado">OK</b-button>
    </b-modal>

    <h4 class="cardD">Pago Complementario</h4>
    <div class="mt-4 col-md-8">
      <ValidationProvider
        name="liga_pago"
        rules="required"
        v-slot="{ errors }"
        :custom-messages="{ required: 'La liga de pago es requerida' }"
      >
        <b-form-group label="Liga de pago Openpay" label-for="input-link-pago-complementario">
          <b-input-group class="mt-3">
            <b-input-group-append>
              <b-button
                :variant="isTextCopied ? 'success' : 'secondary'"
                squared
                v-b-tooltip.hover
                title="Copiar"
                @click="copyLinkToClipboard"
              >
                <b-icon v-if="isTextCopied" icon="check"></b-icon>
                <b-icon v-else icon="clipboard"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-input
              id="input-link-pago-complementario"
              type="url"
              v-model="liga_pago"
              :disabled="[18, 19, 20, 21, 74, 75, 76].includes(cotejo.id_estatus) && !cotejo.staff"
              placeholder="Link Openpay"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <h4 class="cardD">Concepto(s) de pago</h4>
    <div class="row" v-for="concepto in conceptos_pago" :key="concepto.id">
      <div class="col-md-4">
        <b-form-group label="Concepto" :label-for="`input-concepto-pago-concepto${concepto.id}`">
          <b-form-input
            :id="`input-concepto-pago-concepto${concepto.id}`"
            type="text"
            v-model="concepto.concepto"
            :disabled="false"
            placeholder="Descripción"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Monto" :label-for="`input-concepto-pago-pago${concepto.id}`">
          <b-form-input
            :id="`input-concepto-pago-pago${concepto.id}`"
            type="number"
            v-model="concepto.monto"
            :disabled="false"
            placeholder="Monto"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div class="row mt-4">
      <b-button variant="success" class="btn-fill" size="sm" @click="addConceptoPago" :disabled="false">
        Agregar concepto
      </b-button>
    </div>

    <div class="row mt-1">
      <div class="col-md-6">
        <h4 class="cardD">Total</h4>
      </div>
      <div class="col-md-6">
        <h4 class="cardD">{{ montoTotalConceptosPagoComputed }}</h4>
      </div>
    </div>

    <h4 class="cardD">Datos Openpay</h4>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Fecha de pago" label-for="input-openpay-fecha-pago">
          <b-form-input id="input-openpay-fecha-pago" type="date" v-model="openpayFechaPago" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Método de pago" label-for="input-openpay-metodo-pago">
          <b-form-input id="input-openpay-metodo-pago" type="text" v-model="openpayMetodoPago" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Cantidad pagada" label-for="input-openpay-cantidad-pagada">
          <b-form-input
            id="input-openpay-cantidad-pagada"
            type="number"
            v-model="openpayCantidadPagada"
            :disabled="false"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Factura Adicional" label-for="input-openpay-factura-adicional">
          <b-form-input
            id="input-openpay-factura-adicional"
            type="number"
            v-model="openpayFacturaAdicional"
            :disabled="false"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div class="mt-4 col-md-4">
      <b-form-group :label="'Monto del pago complementario: ' + montoFormatter" label-for="inputMonto">
        <validation-provider rules="required" v-slot="{ errors }" :custom-messages="{ required: 'El monto es requerido.' }">
          <b-form-input
            id="inputMonto"
            v-model="monto"
            type="number"
            :disabled="!cotejo.staff"
            placeholder="Monto"
          ></b-form-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </validation-provider>
      </b-form-group>
    </div>

    <b-row v-if="cotejo.staff">
      <b-col class="d-flex justify-content-end">
        <b-button class="btn-fill" @click="openConfirmPagoModal">Guardar</b-button>
        <b-button
          class="btn-fill orange-btn"
          @click="openConfirmPagadoModal"
          :disabled="!cotejo.id_cotizaciones_complementario"
        >
          Validar Pago
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CotizacionesApi, FuncionesApi, LayoutsApi } from "@/api";
import { formatCurrency } from "@/utils/number-utils";
import { useUIStateStore } from "@/stores";

export default {
  name: "PagoComplementario",

  props: {
    cotejo: { type: Object },
  },

  setup() {
    const uiStateStore = useUIStateStore();

    return { uiStateStore };
  },

  data() {
    return {
      isTextCopied: false,
      existeCotizacionComplementaria: false,

      cotizacionComplementaria: {},
      cotizacion_complementaria_id: null,
      monto: 0,
      liga_pago: "",
      conceptos_pago: [],
      openpayFechaPago: "",
      openpayMetodoPago: "",
      openpayCantidadPagada: 0,
      openpayFacturaAdicional: "",
    };
  },

  computed: {
    montoFormatter() {
      return formatCurrency(this.monto);
    },

    montoTotalConceptosPagoComputed() {
      const total = this.conceptos_pago.reduce((total, concepto) => {
        return total + Number.parseInt(concepto.monto);
      }, 0);

      this.monto = total;

      return formatCurrency(total);
    },
  },

  async mounted() {
    if (!this.cotejo.id_cotizaciones_complementario) {
      this.addConceptoPago();
      return;
    }

    this.fetchCotizacionComplementaria();
  },

  methods: {
    async fetchCotizacionComplementaria() {
      try {
        this.uiStateStore.startLoading();

        const cotizacion = await CotizacionesApi.detail(this.cotejo.id_cotizaciones_complementario);

        this.cotizacion_complementaria_id = cotizacion.id;
        this.cotizacionComplementaria = cotizacion;
        this.liga_pago = cotizacion.liga_pago;
        this.conceptos_pago = cotizacion.conceptos.conceptos_pago;
        this.openpayFechaPago = cotizacion.conceptos.openpayFechaPago;
        this.openpayMetodoPago = cotizacion.conceptos.openpayMetodoPago;
        this.openpayCantidadPagada = cotizacion.conceptos.openpayCantidadPagada;
        this.openpayFacturaAdicional = cotizacion.conceptos.openpayFacturaAdicional;
        this.existeCotizacionComplementaria = true;
      } catch (error) {
        console.log(error);
        this.showErrorToast("Ocurrió un error al recuperar la información, intente más tarde.");
      } finally {
        this.uiStateStore.stopLoading();
      }
    },

    copyLinkToClipboard() {
      if (!this.liga_pago) {
        return;
      }

      navigator.clipboard.writeText(this.liga_pago).then((this.isTextCopied = true));
    },

    addConceptoPago() {
      this.conceptos_pago.push({
        id: this.conceptos_pago.length + 1,
        concepto: "",
        monto: 0,
      });
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    openConfirmPagoModal() {
      if (!this.liga_pago) {
        this.showErrorToast("Por favor ingrese una liga de pago.");
        return;
      }

      if (!this.monto || this.monto <= 0) {
        this.showErrorToast("Por favor ingrese un monto válido.");
        return;
      }

      this.$refs["modal-confirm-mail"].show();
    },

    openConfirmPagadoModal() {
      this.$refs["modal-confirm-pagado"].show();
    },

    async guardarHandler() {
      try {
        this.uiStateStore.startLoading();
        this.$refs["modal-confirm-mail"].hide();

        if (!this.existeCotizacionComplementaria) {
          await this.createCotizacionComplementaria();
        } else {
          await this.editCotizacionComplementaria();
        }

        await this.sendMailRequestPagoComplementario();

        this.submitPagoComplementario();
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error, intente más tarde");
      } finally {
        this.uiStateStore.stopLoading();
      }
    },

    async createCotizacionComplementaria() {
      const { id } = await CotizacionesApi.create({
        precio_total: this.monto,
        liga_pago: this.liga_pago,
        activo: 1,
        conceptos: {
          conceptos_pago: this.conceptos_pago,
          openpayFechaPago: this.openpayFechaPago,
          openpayMetodoPago: this.openpayMetodoPago,
          openpayCantidadPagada: this.openpayCantidadPagada,
          openpayFacturaAdicional: this.openpayFacturaAdicional,
        },
      });

      this.id_cotizaciones_complementario = id;
      this.cotejo.id_cotizaciones_complementario = id;
    },

    async editCotizacionComplementaria() {
      await CotizacionesApi.edit(this.cotizacion_complementaria_id, {
        id: this.cotizacion_complementaria_id,
        precio_total: this.monto,
        liga_pago: this.liga_pago,
        activo: 1,
        conceptos: {
          conceptos_pago: this.conceptos_pago,
          openpayFechaPago: this.openpayFechaPago,
          openpayMetodoPago: this.openpayMetodoPago,
          openpayCantidadPagada: this.openpayCantidadPagada,
          openpayFacturaAdicional: this.openpayFacturaAdicional,
        },
      });
    },

    async processPagado() {
      try {
        this.uiStateStore.startLoading();
        this.$refs["modal-confirm-pagado"].hide();
        await this.sendMailPagadoComplementario();
        this.$emit("pagadoComplementario");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error, intente más tarde");
      } finally {
        this.uiStateStore.stopLoading();
      }
    },

    async sendMailRequestPagoComplementario() {
      const solicitante_o_representante = this.cotejo.solicitantes.find((obj) => obj.persona == "Física");
      const email = solicitante_o_representante.email;
      const layout = await LayoutsApi.detail(26);

      layout.body = layout.body.replace("{liga_pago}", this.liga_pago);

      await FuncionesApi.sendMail({
        emailTo: email,
        body: layout.body,
        subject: layout.subject,
      });

      this.$toast.success("Se ha notificado al cliente correctamente.", {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async sendMailPagadoComplementario() {
      const solicitante_o_representante = this.cotejo.solicitantes.find((obj) => obj.persona == "Física");
      const email = solicitante_o_representante.email;
      const layout = await LayoutsApi.detail(26);

      layout.body = layout.body.replace("{liga_pago}", this.liga_pago);

      await FuncionesApi.sendMail({
        emailTo: email,
        body: layout.body,
        subject: layout.subject,
      });

      this.$toast.success("Se ha notificado al cliente correctamente.", {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    submitPagoComplementario() {
      this.uiStateStore.stopLoading();
      this.$emit("allChecksPassed");
    },
  },
};
</script>
